import { useEffect, useSyncExternalStore } from 'react'
import { useCmsVersion } from '../cms/store'
import { DEFAULT_AUTHOR } from '../lib/cms'
import { api, type AdminAuthor } from './api'

type Snapshot = {
  authors: AdminAuthor[]
  loaded: boolean
}

let snapshot: Snapshot = { authors: [], loaded: false }
const listeners = new Set<() => void>()

function emit() {
  listeners.forEach((listener) => listener())
}

function subscribe(onStoreChange: () => void) {
  listeners.add(onStoreChange)
  return () => {
    listeners.delete(onStoreChange)
  }
}

function getSnapshot() {
  return snapshot
}

export async function refreshAdminAuthors() {
  const people = await api<AdminAuthor[]>('/api/admin/authors')
  snapshot = { authors: sortAuthors(people), loaded: true }
  emit()
  return snapshot.authors
}

function sortAuthors(people: AdminAuthor[]) {
  return [...people].sort((a, b) => {
    const aDefault = a.slug === 'sky' || a.name === DEFAULT_AUTHOR
    const bDefault = b.slug === 'sky' || b.name === DEFAULT_AUTHOR
    if (aDefault && !bDefault) return -1
    if (bDefault && !aDefault) return 1
    return a.name.localeCompare(b.name)
  })
}

export function useAdminAuthors() {
  const cmsVersion = useCmsVersion()
  const current = useSyncExternalStore(subscribe, getSnapshot)

  useEffect(() => {
    void refreshAdminAuthors().catch(() => {
      snapshot = { ...snapshot, loaded: true }
      emit()
    })
  }, [cmsVersion])

  return current
}
